document.addEventListener('DOMContentLoaded', () => {
  const searchButton = document.querySelector('.js-address-search');
  if (!searchButton) return;

  searchButton.addEventListener('click', async (e) => {
    e.preventDefault();
    const zipCode = document.querySelector('.js-zip').value.replace(/[^\d]/g, '');
    
    if (!zipCode) {
      alert('郵便番号を入力してください');
      return;
    }

    try {
      const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipCode}`);
      const data = await response.json();
      
      if (data.results && data.results.length > 0) {
        const address = data.results[0];
        
        // 都道府県のセレクトボックスを更新
        const prefSelect = document.querySelector('.js-prefecture');
        Array.from(prefSelect.options).forEach(option => {
          if (option.text === address.address1) {
            prefSelect.value = option.value;
          }
        });

        // 市区町村を設定
        const cityInput = document.querySelector('.js-city');
        cityInput.value = address.address2 + address.address3;
      } else {
        alert('郵便番号に該当する住所が見つかりませんでした。\n正しい郵便番号を入力してください。');
      }
    } catch (error) {
      console.error('住所検索でエラーが発生しました:', error);
      alert('住所検索でエラーが発生しました。\n時間をおいて再度お試しください。');
    }
  });
}); 